export default __webpack_public_path__ + "static/media/party.cb9301c7.svg";